module.exports = __webpack_public_path__ + "img/bigwin-text.8cd34db8.png";